<template>
  <v-card
    @mouseenter="hover = true"
    @mouseleave="hover = false"
    class="d-relative overflow-hidden"
  >
    <v-fade-transition>
      <v-overlay
        v-show="hover"
        absolute
        color="primary"
      >
        <v-dialog
          v-model="dialog"
          attach="#app"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              icon
              v-on="on"
              :attrs="attrs"
              class="mr-2"
            >
              <v-icon>mdi-eye</v-icon>
            </v-btn>
            <v-btn
              text
              icon
              @click="deleteDialog = true"
            >
              <v-icon color="error">mdi-delete</v-icon>
            </v-btn>
          </template>
          <v-card
            :style="{
              position: 'relative',
              height: $vuetify.breakpoint.height - 100 + 'px'
            }"
          >
            <v-btn
              @click="dialog = false"
              :style="{
                position: 'absolute',
                top: '25px',
                right: '55px',
                zIndex: 99
              }"
              ><v-icon left>mdi-close</v-icon>{{ $t("commons.close") }}</v-btn
            >
            <div style="height: 100% !important; overflow: auto">
              <v-img
                contain
                :src="image.file_url"
              ></v-img>
            </div>
          </v-card>
        </v-dialog>
      </v-overlay>
    </v-fade-transition>
    <v-img
      height="90"
      :src="image.file_url"
    ></v-img>
    <v-dialog
      v-model="deleteDialog"
      width="500"
    >
      <v-card>
        <v-card-title class="headline">
          {{ $t("actions.delete", { entity: $t("commons.capture").toLowerCase() }) }}
        </v-card-title>

        <v-card-text>
          {{ $t("message.informations.delete_capture.question") }}<br />
          {{ $t("message.informations.delete_capture.prevention") }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="deleteDialog = false"
          >
            {{ $t("commons.cancel") }}
          </v-btn>
          <v-btn
            color="error"
            @click="deletePicture"
          >
            {{ $t("actions.delete", { entity: "" }) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import PictureService from "@/services/PictureService"
export default {
  name: "ImageCaptureItem",
  components: {},
  props: {
    image: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      dialog: false,
      hover: false,
      deleteDialog: false
    }
  },
  methods: {
    deletePicture() {
      PictureService.remove(this, this.image.id)
        .then(r => {
          this.$emit("deleted")
        })
        .finally(() => {
          this.deleteDialog = false
        })
    }
  }
}
</script>

<style scoped>
.d-relative {
  position: relative;
}
</style>
